import PrintLabel from '@/store/modules/printLabel/constants';

export default {
  [PrintLabel.mutations.setPrintLabelInfo](state, printLabelInfo) {
    const localState = state;

    localState.printLabelInfo = printLabelInfo;
  },

  [PrintLabel.mutations.setLoading](state, loading) {
    const localState = state;

    localState.loading = loading;
  },

  [PrintLabel.mutations.setError](state, error) {
    const localState = state;

    localState.error = error;
  },
};
